import { FC, PropsWithChildren } from "react";

interface ModalProps extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose,  children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-stone-300">
      <div className="fixed inset-0 bg-white opacity-0"></div>
      <div className="bg-white p-4 shadow-lg z-10 max-w-7xl rounded-lg">
        <div className="flex justify-end p-4  rounded-t">
          <button type="button" onClick={() => onClose()}>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div className="mb-4 w-full p-4 overflow-x-auto max-h-[400px]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
